import { useEffect, useState } from "react";
import Textfield from "../../components/inputs/textfield";
import { useNavigate } from "react-router-dom";
import useGlobal from "../../../store";
import Button from "../../components/inputs/button";

const AuthPage = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { user_role } = globalState;
  const { sign, changeStates } = globalActions;

  const [ email, setEmail ] = useState("");
  const [ code, setCode ] = useState("");
  const [ isShowCodeField, setShowCodeField ] = useState(false);
  const [ error, setError ] = useState("");

  const isFormValidated = ( email.indexOf('@') !== -1 && email.indexOf('.') !== -1 );

  const navigate = useNavigate();

  // async function checkRole() {

  //   const data = await sign.CheckRole();
  //   console.log('checkRole auth data', data);

  // }

  const redirect = () => {
  
    console.log('redirect called');
    // checkRole();
    navigate('/');

  }

  async function handleSignIn() {

    if ( !code?.length ) { setShowCodeField( true ); }
    
    return await sign.In({ 
      
      email, 
      code: code?.length ? code : undefined, 
      onSuccess: redirect,
      onError: setError
    
    });
  
  }

  // useEffect(() => {

  //   !user_role 
  //     ? navigate('/auth')
  //     : user_role === 'super_admin' 
  //       ? navigate('/admins')
  //       : user_role === 'content_manager'
  //         ? navigate('/admins')
  //         : navigate('/auth');

  // }, [ user_role ]);

  useEffect(() => { 
    
    error !== "" && setError("") 
  
  }, [ email, code ]);

  return (

    <div className = "flex-1 grid justify-center items-center">

      <div>

        <h2>Авторизация</h2>
        <br/>

        <Textfield

          title = "E-mail"
          value = { email }
          set = { setEmail }
          onKeyUp = { e => e.key === "Enter" && handleSignIn() }

        />

        { isShowCodeField && 
        
          <Textfield

            title = "Код из e-mail:"
            value = { code }
            set = { setCode }
            onKeyUp = { e => e.key === "Enter" && handleSignIn() }

          />
          
        }

        { error !== "" && <p className = "error">{ error }</p> }

        <Button 
        
          action = { handleSignIn }
          disabled = { !isFormValidated }
          
        >

          Войти

        </Button>

      </div>

    </div>

  );

}

export default AuthPage;